/**
 * 请求数据配置
 * 配置编译环境和线上环境之间的IP切换
 *
 * baseURL: 域名地址
 * fileUpBaseUrl:上传文件
 **/
var baseURL = 'https://api.zhongyaohang.top'
var fileUpBaseUrl = ''
var Img_prefix =baseURL
var oss =baseURL 
 
 module.exports = {
  baseURL,
  fileUpBaseUrl,
  Img_prefix,
  oss,  
  	//配后端数据的接收方式application/json;charset=UTF-8或者application/x-www-form-urlencoded;charset=UTF-8
	contentType: 'application/json;charset=UTF-8',
  debounce: ['doEdit'],
	//消息框消失时间
	messageDuration: 3000,
	//最长请求时间
	requestTimeout: 50000,
	//操作正常code，支持String、Array、int多种类型
	successCode: [200, 1],
	//登录失效code
	invalidCode: 402,
	//无权限code
	noPermissionCode: 401,   
  tokenName: 'Authorization',
  loginInterception: true,
  tokenTableName: 'three3D',
  //token存储位置localStorage sessionStorage
  storage: 'localStorage',
}
